<obg-m-dialog-layout
	#dialog
	*ngIf="welcomeMessageKey"
	titleText="{{ welcomeMessageKey | translate:{'name':name} }}"
	dialogId="customer-verification"
	data-test-id="customer-verification"
	[hideFooter]="!showHeaderAndFooter"
	[navbar]="showHeaderAndFooter"
	[navbarOptions]="navbarOptions"
>
	<obg-m-customer-verification-container
		[username]="username"
		[variant]="variant"
		(dismissDialog)="closeDialog($event)"
		cdk-focus-start
	>
	</obg-m-customer-verification-container>
</obg-m-dialog-layout>
